{
  "a11y": {
    "skipToContent": "Skip to content",
    "dnd": {
      "instructions": "To pick up an entry, press Space or Enter. Use the arrow keys to move it, then Space or Enter to drop it, or Escape to cancel.",
      "pickedUp": "Picked up {{name}}. Position {{position}} of {{total}}.",
      "over": "{{name}} is now at position {{position}} of {{total}}.",
      "dropped": "{{name}} dropped at position {{position}} of {{total}}.",
      "cancelled": "Moving {{name}} was cancelled."
    }
  },
  "nav": {
    "label": "Main",
    "lists": "Lists",
    "categories": "Categories",
    "search": "Search",
    "favorites": "Favorites",
    "shared": "Shared",
    "profile": "Profile",
    "settings": "Settings",
    "notifications": "Notifications",
    "meals": "Recipes",
    "archived": "Archived",
    "sponsoredAdmin": "Sponsored lists",
    "accountMenu": "Account menu",
    "catalogAdmin": "Catalog items",
    "admin": "Admin"
  },
  "common": {
    "back": "Back",
    "cancel": "Cancel",
    "close": "Close",
    "dismiss": "Dismiss",
    "loadMore": "Load more",
    "loading": "Loading…",
    "reload": "Reload",
    "retry": "Try again",
    "save": "Save",
    "undo": "Undo",
    "pagination": "Pages",
    "previous": "Previous",
    "next": "Next",
    "pageOf": "Page {{page}} of {{pages}}"
  },
  "auth": {
    "tagline": "Shopping lists you can share with the people you shop for.",
    "sample": {
      "milk": "Milk",
      "bread": "Bread",
      "tomatoes": "Tomatoes",
      "coffee": "Coffee"
    },
    "backToLogin": "Back to log in",
    "sessionExpired": "You were signed out. Log in again to continue.",
    "passwordHint": "At least {{min}} characters. A short sentence works well.",
    "fields": {
      "email": "Email",
      "password": "Password",
      "displayName": "Your name",
      "newPassword": "New password",
      "confirmPassword": "Confirm new password",
      "country": "Country (optional)",
      "countryHint": "We use it to show offers from stores near you. You can change it in your profile.",
      "countryNone": "Prefer not to say",
      "useLocation": "Use my location",
      "locateFailed": "We couldn't find your country from your location. Choose it from the list."
    },
    "errors": {
      "email": "Enter a valid email address.",
      "passwordRequired": "Enter your password.",
      "passwordLength": "Use at least {{min}} characters.",
      "passwordWeak": "This password is too easy to guess. Try a longer phrase.",
      "passwordMismatch": "The passwords don't match.",
      "displayName": "Enter your name."
    },
    "login": {
      "title": "Login",
      "intro": "Welcome back. Your lists are waiting.",
      "submit": "Login",
      "forgot": "Forgot password?",
      "noAccount": "New to Lista?",
      "createAccount": "Create an account",
      "invalid": "That email and password don't match. Check them and try again."
    },
    "register": {
      "title": "Create your account",
      "intro": "Free, and ready in a minute.",
      "submit": "Create account",
      "haveAccount": "Already have an account?",
      "checkEmailTitle": "Check your email",
      "checkEmail": "We sent a link to {{email}}. Open it to verify your address, then log in.",
      "goToLogin": "Go to log in"
    },
    "forgot": {
      "title": "Reset your password",
      "intro": "Enter your email and we'll send you a link to set a new password.",
      "submit": "Send reset link",
      "sent": "If {{email}} has an account, a reset link is on its way. It works for 30 minutes."
    },
    "reset": {
      "title": "Set a new password",
      "intro": "Choose a new password. You'll be signed out on your other devices.",
      "submit": "Save new password",
      "done": "Password changed. Log in with your new password.",
      "invalid": "This reset link has expired or was already used.",
      "requestNew": "Request a new link"
    },
    "verify": {
      "title": "Verify your email",
      "checking": "Checking your link…",
      "done": "Your email is verified. You can now accept shared lists.",
      "invalid": "This verification link has expired or was already used.",
      "continue": "Continue to your lists"
    }
  },
  "errors": {
    "generic": "Something went wrong. Try again.",
    "network": "You're offline or the server can't be reached. Check your connection and try again.",
    "loadFailed": "Couldn't load this",
    "crashTitle": "This screen stopped working",
    "crashBody": "Reload the app to continue. Your lists are saved.",
    "newVersion": "A new version is available",
    "newVersionBody": "Reload to get the latest version of Lista.",
    "codes": {
      "VALIDATION_FAILED": "Some details aren't valid. Check the form and try again.",
      "UNAUTHENTICATED": "Log in to continue.",
      "TOKEN_EXPIRED": "Your session ended. Log in again.",
      "INVALID_CREDENTIALS": "That email and password don't match.",
      "EMAIL_NOT_VERIFIED": "Verify your email address first.",
      "FORBIDDEN": "You don't have permission to do that.",
      "LIST_NOT_FOUND": "This list doesn't exist or isn't shared with you.",
      "INSUFFICIENT_LIST_ROLE": "Your permission on this list doesn't allow that.",
      "LIST_ARCHIVED": "This list is archived. Unarchive it to make changes.",
      "LIST_DELETED": "This list was deleted.",
      "LIST_LIMIT": "You've reached the maximum of 200 lists. Delete a list to create a new one.",
      "VERSION_MISMATCH": "This list was changed by someone else. We've loaded the latest version.",
      "PRECONDITION_REQUIRED": "Refresh the list and try again.",
      "LIST_ITEM_LIMIT": "A list can hold up to 500 items.",
      "QUANTITY_LIMIT": "The quantity can't be more than 9,999.",
      "STALE_POSITION": "The list changed. Refresh and try again.",
      "CUSTOM_ITEM_LIMIT": "You've reached the limit of custom items.",
      "FAVORITE_LIMIT": "You can have up to 1,000 favorites.",
      "LIST_MEMBER_LIMIT": "A list can be shared with up to 50 people.",
      "ALREADY_MEMBER": "This person already has access to the list.",
      "ALREADY_INVITED": "This person has already been invited.",
      "CANNOT_SHARE_WITH_SELF": "That's your own email address.",
      "CANNOT_CHANGE_OWNER_ROLE": "The owner's permission can't be changed.",
      "CANNOT_REMOVE_OWNER": "The owner can't be removed.",
      "OWNER_CANNOT_LEAVE": "The owner can't leave. Delete the list instead.",
      "MEMBER_NOT_FOUND": "This person is no longer on the list.",
      "INVITATION_INVALID": "This invitation has expired or was already used.",
      "INVITATION_EMAIL_MISMATCH": "This invitation was sent to a different email address.",
      "RATE_LIMITED": "Too many attempts. Wait a moment and try again.",
      "AI_UNAVAILABLE": "Reading photos isn't available right now. Try again in a minute.",
      "PDF_UNAVAILABLE": "PDF export isn't available right now. Try again in a minute.",
      "NOT_FOUND": "We couldn't find that.",
      "CONFLICT": "That conflicts with something that already exists.",
      "INTERNAL_ERROR": "Something went wrong on our side. Try again.",
      "SHARE_NOT_FOUND": "This share is no longer available.",
      "CUISINE_NOT_FOUND": "This cuisine does not exist.",
      "MEAL_NOT_FOUND": "This recipe does not exist.",
      "SHARE_LINK_NOT_FOUND": "This link isn't valid any more.",
      "SHARE_LINK_LIMIT": "This list already has the maximum number of active links. Turn one off first."
    }
  },
  "dashboard": {
    "title": "My lists",
    "filterLabel": "Show",
    "filters": {
      "all": "All",
      "owned": "Mine",
      "sharing": "Lists I share",
      "shared": "Shared with me",
      "archived": "Archived"
    },
    "sortLabel": "Sort",
    "sort": {
      "custom": "Custom",
      "updatedAt": "Date modified",
      "createdAt": "Date created",
      "name": "Name"
    },
    "empty": {
      "all": {
        "title": "No lists yet",
        "body": "Create a list for your weekly shop, a party or anything you need to buy."
      },
      "owned": {
        "title": "You haven't created a list",
        "body": "Create one and share it when you're ready."
      },
      "sharing": {
        "title": "You're not sharing any lists",
        "body": "Share one of your lists and it shows up here."
      },
      "shared": {
        "title": "Nothing shared with you yet",
        "body": "When someone shares a list with you, it shows up here."
      },
      "archived": {
        "title": "No archived lists",
        "body": "Archive lists you're done with to keep this page tidy."
      }
    }
  },
  "lists": {
    "untitled": "Untitled List",
    "new": "New list",
    "create": "Create list",
    "createTitle": "New list",
    "editTitle": "Edit list",
    "name": "List name",
    "namePlaceholder": "e.g. Weekly groceries",
    "color": "Colour",
    "open": "Open",
    "edit": "Edit",
    "archive": "Archive",
    "unarchive": "Unarchive",
    "delete": "Delete",
    "actionsFor": "Actions for {{name}}",
    "created": "Created {{name}}",
    "saved": "List saved",
    "archived": "Archived {{name}}",
    "unarchived": "Unarchived {{name}}",
    "deleted": "Deleted {{name}}",
    "changedElsewhere": "Someone else changed this list. We've loaded the latest version - try again.",
    "deleteConfirm": {
      "title": "Delete {{name}}?",
      "body": "Everyone it's shared with loses access. You can't undo this from the app."
    },
    "errors": {
      "nameRequired": "Give the list a name."
    },
    "noItemsYet": "No items yet",
    "allDone": "All bought",
    "remaining_one": "item left",
    "remaining_other": "items left",
    "items_one": "{{formatted}} item",
    "items_other": "{{formatted}} items",
    "itemCount": "Items",
    "lastUpdated": "Last updated",
    "sharing": "Sharing",
    "status": "Status",
    "progressLabel": "Bought so far",
    "sharedWith_one": "Shared with 1 person",
    "sharedWith_other": "Shared with {{count}} people",
    "sharedBy": "From {{name}}",
    "archivedBadge": "Archived",
    "updated": "Updated {{when}}",
    "dragHandle": "Move {{name}}",
    "previewLabel": "Items in this list",
    "previewMore": "+{{formatted}} more",
    "pin": "Pin to top",
    "duplicate": "Duplicate list",
    "copyOf": "Copy of {{name}}",
    "duplicated": "Created {{name}}",
    "shareName": "Share {{name}}",
    "pinName": "Pin {{name}}",
    "unpinName": "Unpin {{name}}",
    "unpin": "Unpin",
    "pinned": "Pinned {{name}}",
    "unpinned": "Unpinned {{name}}",
    "pinnedBadge": "Pinned"
  },
  "list": {
    "addItem": "Add item",
    "titleLabel": "List name",
    "editTitle": "Click to rename",
    "editTitleName": "Rename {{name}}",
    "collapseCategory": "Collapse {{name}}",
    "expandCategory": "Expand {{name}}",
    "share": "Share",
    "private": "Only you",
    "tally_one": "left of {{total}}",
    "tally_other": "left of {{total}}",
    "tallyEmpty": "items - add your first one",
    "archivedBanner": "This list is archived and read-only.",
    "viewerBanner": "You can view this list. Ask the owner for edit access to change it.",
    "findPlaceholder": "Find in this list",
    "findLabel": "Find an item in this list",
    "categoryFilter": "Filter by category",
    "allCategories": "All",
    "otherCategory": "Other",
    "boughtSection_one": "Bought ({{count}})",
    "boughtSection_other": "Bought ({{count}})",
    "everythingBought": "Everything on this list is bought.",
    "noMatches": "No items match",
    "empty": {
      "title": "This list is empty",
      "body": "Search for items or browse categories to add them.",
      "readOnly": "Nothing to buy yet."
    },
    "notFound": {
      "title": "List not found",
      "body": "It may have been deleted, or it isn't shared with you anymore.",
      "action": "Go to my lists"
    },
    "sharedBy": {
      "EDITOR": "{{name}}'s list. You can edit it.",
      "VIEWER": "{{name}}'s list. You can view it.",
      "OWNER": "Your list"
    },
    "order": {
      "label": "Show items",
      "category": "By category",
      "custom": "Custom",
      "createdAt": "Date added",
      "updatedAt": "Date modified",
      "dragHint": "Drag items by their handle to arrange the list."
    },
    "view": {
      "label": "View",
      "rows": "Rows",
      "tiles": "Tiles"
    }
  },
  "items": {
    "addTitle": "Add items",
    "searchPlaceholder": "Milk, bread, tomatoes…",
    "searchLabel": "Search items to add",
    "browseLabel": "Browse",
    "quickAdd": "Add {{name}}",
    "addCustom": "Add “{{name}}”",
    "addCustomDetail": "As a new item",
    "newItemNote": "This will be saved to your items so you can find it again.",
    "onList": "On list: {{quantity}}",
    "backToResults": "Back",
    "allCategories": "All categories",
    "quantity": "Quantity",
    "unit": "Unit",
    "note": "Notes",
    "notePlaceholder": "Brand, size, ripeness…",
    "decrease": "Decrease quantity",
    "increase": "Increase quantity",
    "errors": {
      "quantity": "Enter a number between 0.001 and 9,999."
    },
    "addToList": "Add to list",
    "addToListTitle": "Add {{name}}",
    "chooseList": "List",
    "added": "Added {{name}}",
    "addedTo": "Added {{name}} to {{list}}",
    "addedToMany": "Added {{name}} to {{count}} lists",
    "targets": {
      "addTo": "Add to",
      "label": "Add to: {{lists}}. Choose lists",
      "choose": "Choose lists",
      "many": "{{name}} +{{count}}",
      "legend": "Add items to these lists",
      "noneSelected": "Choose at least one list to add to",
      "failed": "Couldn't add to {{list}}: {{reason}}"
    },
    "saved": "Saved {{name}}",
    "removed": "Removed {{name}}",
    "remove": "Remove",
    "removeName": "Remove {{name}} from this list",
    "removeConfirm": {
      "title": "Remove {{name}}?",
      "body": "It disappears from this list for everyone."
    },
    "bought": "Bought",
    "boughtBy": "Bought by {{name}}",
    "readOnly": "You can view this item but not change it.",
    "markBought": "Mark {{name}}, {{quantity}}, as bought",
    "markNotBought": "Mark {{name}}, {{quantity}}, as not bought",
    "openItem": "Edit {{name}}",
    "noWritableLists": {
      "title": "No list to add to",
      "body": "Create a list first, or ask for edit access to a shared one.",
      "action": "Go to my lists"
    },
    "recent": {
      "tab": "Recent",
      "emptyTitle": "Nothing here yet",
      "emptyBody": "Items you add to any list show up here, newest first.",
      "title": "Recently used"
    },
    "dragHandle": "Move {{name}}"
  },
  "catalog": {
    "categoriesTitle": "Categories",
    "itemCount_one": "{{count}} item",
    "itemCount_other": "{{count}} items",
    "emptyCategory": "No items in this category yet",
    "addToList": "Add to list",
    "addNameToList": "Add {{name}} to a list",
    "addNameToTargets": "Add {{name}} to the selected lists",
    "myItem": "My item"
  },
  "search": {
    "title": "Search",
    "placeholder": "Search in English or Arabic",
    "label": "Search items",
    "categories": "Matching categories",
    "prompt": {
      "title": "Find anything to buy",
      "body": "Type at least two letters. Small typos are fine."
    },
    "noResults": {
      "title": "Nothing found for “{{q}}”",
      "body": "Check the spelling, or add it as a new item from a list."
    }
  },
  "favorites": {
    "title": "Favorites",
    "searchPlaceholder": "Search favorites",
    "searchLabel": "Search your favorites",
    "noMatches": "No favorites match “{{q}}”",
    "add": "Add to favorites",
    "remove": "Remove from favorites",
    "addName": "Add {{name}} to favorites",
    "removeName": "Remove {{name}} from favorites",
    "added": "{{name}} added to favorites",
    "removed": "{{name}} removed from favorites",
    "isFavorite": "Favorite",
    "discontinued": "No longer in the catalog",
    "empty": {
      "title": "No favorites yet",
      "body": "Tap the star on any item to keep it here.",
      "action": "Browse categories",
      "inPanel": "Star items you buy often and they'll appear here."
    }
  },
  "shared": {
    "title": "Shared lists",
    "withMe": "Shared with me",
    "byMe": "Lists I share",
    "emptyWithMe": {
      "title": "Nothing shared with you yet",
      "body": "When someone shares a list with you, it appears here."
    },
    "emptyByMe": {
      "title": "You're not sharing any lists",
      "body": "Open a list and choose Share to invite people."
    },
    "pendingTitle": "Waiting for your answer",
    "pendingHint": "Accept a list to start using it. Until then you cannot open it.",
    "pendingBadge": "Pending acceptance",
    "pendingBy": "{{name}} shared this list with you",
    "pendingRole": "{{role}} permission",
    "accept": "Accept",
    "acceptName": "Accept {{name}}",
    "accepting": "Accepting…",
    "acceptedToast": "You joined {{name}}",
    "pendingLoadFailed": "Couldn't load pending shares",
    "decline": "Decline",
    "declining": "Declining…",
    "declinedToast": "You declined {{name}}"
  },
  "sharing": {
    "title": "Share {{name}}",
    "addPeople": "Add people",
    "emailPlaceholder": "Email address",
    "permission": "Permission",
    "permissionFor": "Permission for {{name}}",
    "add": "Add",
    "addHint": "People with a Lista account get a request they must accept; others get an email invitation.",
    "added": "Share request sent to {{email}}",
    "invited": "Invitation sent to {{email}}",
    "people_one": "1 person",
    "people_other": "{{count}} people",
    "you": "You",
    "ownerSince": "Owner since {{date}}",
    "sharedOn": "Shared on {{date}}",
    "invitedOn": "Invited {{date}}, expires {{expires}}",
    "pending": "Waiting to join",
    "remove": "Remove",
    "removeName": "Remove {{name}}",
    "removed": "Removed {{name}}",
    "removeConfirm": {
      "title": "Remove {{name}}?",
      "body": "They'll lose access to {{list}}."
    },
    "leave": "Leave list",
    "left": "You left {{name}}",
    "leaveConfirm": {
      "title": "Leave {{name}}?",
      "body": "You'll need a new invitation to see this list again."
    },
    "revoke": "Cancel invitation for {{email}}",
    "revoked": "Invitation for {{email}} cancelled",
    "roleChanged": "Permission updated for {{name}}",
    "rolesHelp": "Editors add and remove items, change quantities, tick items off and add notes. Viewers can only look.",
    "invitationTitle": "You're invited to a list",
    "invitationIntro": "Someone shared a Lista shopping list with you.",
    "acceptInvitation": "Accept invitation",
    "accepted": "You've joined the list",
    "loginToAccept": "Login to accept",
    "registerToAccept": "Create an account to accept",
    "acceptErrors": {
      "notVerified": "Verify your email address first - check your inbox for the link.",
      "mismatch": "This invitation was sent to a different email address. Log in with that account.",
      "invalid": "This invitation has expired, was cancelled or was already used."
    },
    "columns": {
      "user": "User",
      "permission": "Permission",
      "shared": "Shared",
      "actions": "Actions"
    },
    "pendingBadge": "Pending",
    "expires": "Invitation expires {{date}}",
    "revokeShort": "Cancel invitation",
    "revokeConfirm": {
      "title": "Cancel the invitation for {{email}}?",
      "body": "The link in their email will stop working."
    },
    "roleHelp": {
      "OWNER": "Full access: changes the list, its items, people and permissions; archives or deletes it.",
      "EDITOR": "Adds and removes items, changes quantities, ticks items off and adds notes.",
      "VIEWER": "Sees the list, its items and quantities. Cannot change anything."
    },
    "whoHasAccess": "Who has access",
    "link": {
      "heading": "Share by link",
      "hint": "Anyone with the link can view this list (read-only) without an account. You can turn a link off at any time.",
      "expiry": "Link expires after",
      "days_one": "{{count}} day",
      "days_other": "{{count}} days",
      "create": "Create link",
      "created": "Link created",
      "active": "Active links",
      "none": "No active links yet.",
      "status": {
        "ACTIVE": "Active",
        "EXPIRED": "Expired"
      },
      "expires": "Expires {{date}}",
      "lastViewed": "Last viewed {{date}}",
      "neverViewed": "Not viewed yet",
      "copy": "Copy link",
      "copied": "Link copied",
      "whatsapp": "WhatsApp",
      "telegram": "Telegram",
      "email": "Email",
      "share": "Share…",
      "more": "Share options",
      "revoke": "Turn off link",
      "revokeConfirm": {
        "title": "Turn off this link?",
        "body": "People who have it will no longer be able to open the list."
      },
      "revoked": "Link turned off",
      "shareText": "{{name}} - shopping list on Lista",
      "emailSubject": "{{name}} - shopping list"
    }
  },
  "roles": {
    "OWNER": "Owner",
    "EDITOR": "Can edit",
    "VIEWER": "Can view"
  },
  "export": {
    "pdf": "PDF",
    "downloadPdf": "Download PDF",
    "sharePdf": "Share PDF",
    "downloaded": "PDF downloaded"
  },
  "profile": {
    "title": "Profile",
    "verified": "Verified",
    "unverified": "Not verified",
    "verifyHint": "Check your inbox for the verification link. You need a verified email to accept shared lists.",
    "memberSince": "Member since {{date}}",
    "details": "Your details",
    "saved": "Profile saved",
    "sessions": "Signed-in devices",
    "sessionsHint": "Sign out here, or on every device if you lost a phone.",
    "signOut": "Sign out",
    "signOutAll": {
      "button": "Sign out everywhere",
      "title": "Sign out on every device?",
      "body": "You'll need to log in again on each phone and computer.",
      "confirm": "Sign out everywhere"
    },
    "goToSettings": "Language, theme and app settings",
    "password": {
      "title": "Password",
      "intro": "Changing your password signs you out on every other device.",
      "current": "Current password",
      "submit": "Change password",
      "changed": "Password changed. Other devices were signed out.",
      "wrongCurrent": "Your current password isn't right.",
      "mustDiffer": "Choose a password you haven't used here."
    },
    "location": {
      "title": "Your location",
      "hint": "Used to suggest items for your country and to show sponsored lists near you.",
      "country": "Country",
      "none": "Not set",
      "city": "City",
      "cityPlaceholder": "e.g. Riyadh"
    },
    "verifyTitle": "Verify your email",
    "verifyResend": "Resend verification email",
    "verifyResendAgain": "Send again",
    "verifySent": "We sent a new verification link to {{email}}. The previous link no longer works."
  },
  "settings": {
    "title": "Settings",
    "switchLanguage": "العربية",
    "switchToDark": "Switch to dark mode",
    "switchToLight": "Switch to light mode",
    "saved": "Settings saved",
    "language": "Language",
    "theme": "Theme",
    "themes": {
      "SYSTEM": "Match device",
      "LIGHT": "Light",
      "DARK": "Dark"
    },
    "units": "Units",
    "unitsHint": "Your preferred measurement system.",
    "unitSystems": {
      "METRIC": "Metric (kg, L)",
      "IMPERIAL": "Imperial (lb, oz)"
    },
    "app": "App",
    "offlineHint": "Lists you've opened stay readable without a connection. Changes need a connection and are sent when it returns, as long as Lista stays open.",
    "install": "Install Lista",
    "installed": "Lista is installed on this device.",
    "installIos": "On iPhone or iPad: tap Share, then Add to Home Screen.",
    "installBrowser": "Use your browser's menu to install Lista or add it to your home screen.",
    "data": {
      "title": "Privacy and your data",
      "intro": "Read how we handle your data, change your cookie choices, download a copy of everything we hold about you, or delete your account.",
      "download": "Download my data",
      "downloaded": "Your data was downloaded",
      "delete": "Delete account",
      "deleteTitle": "Delete your account?",
      "consequenceLists_one": "The list you own will be deleted.",
      "consequenceLists_other": "The {{count}} lists you own will be deleted.",
      "consequenceShared_one": "{{count}} of them is shared: its members will be told it is gone.",
      "consequenceShared_other": "{{count}} of them are shared: their members will be told they are gone.",
      "consequenceData": "Your favorites, custom items, meal plans and notifications will be deleted.",
      "consequenceOthers": "Items you added to other people’s lists stay on those lists.",
      "irreversible": "This cannot be undone.",
      "password": "Enter your password to confirm",
      "passwordRequired": "Enter your password",
      "wrongPassword": "Password is incorrect",
      "deleteConfirm": "Delete my account",
      "deleted": "Your account was deleted. We’ve emailed you a confirmation."
    }
  },
  "pwa": {
    "offline": "You're offline. Showing saved data; changes are sent when you reconnect.",
    "offlineReady": "Lista is ready to work offline",
    "updateAvailable": "A new version of Lista is available",
    "reload": "Reload"
  },
  "notFound": {
    "title": "Page not found",
    "body": "The link may be broken or the page was moved.",
    "action": "Go to my lists"
  },
  "colors": {
    "default": "Plain",
    "red": "Red",
    "orange": "Orange",
    "yellow": "Yellow",
    "green": "Green",
    "teal": "Teal",
    "blue": "Blue",
    "indigo": "Indigo",
    "purple": "Purple",
    "pink": "Pink",
    "brown": "Brown",
    "gray": "Grey"
  },
  "units": {
    "short": {
      "PIECE_one": "pc",
      "PIECE_other": "pcs",
      "KG": "kg",
      "G": "g",
      "LB": "lb",
      "OZ": "oz",
      "L": "L",
      "ML": "mL",
      "PACK_one": "pack",
      "PACK_other": "packs",
      "DOZEN_one": "dozen",
      "DOZEN_other": "dozen",
      "BOTTLE_one": "bottle",
      "BOTTLE_other": "bottles",
      "CAN_one": "can",
      "CAN_other": "cans",
      "BOX_one": "box",
      "BOX_other": "boxes",
      "BAG_one": "bag",
      "BAG_other": "bags",
      "BUNCH_one": "bunch",
      "BUNCH_other": "bunches"
    },
    "long": {
      "PIECE": "Pieces",
      "KG": "Kilograms (kg)",
      "G": "Grams (g)",
      "LB": "Pounds (lb)",
      "OZ": "Ounces (oz)",
      "L": "Litres (L)",
      "ML": "Millilitres (mL)",
      "PACK": "Packs",
      "DOZEN": "Dozen",
      "BOTTLE": "Bottles",
      "CAN": "Cans",
      "BOX": "Boxes",
      "BAG": "Bags",
      "BUNCH": "Bunches"
    }
  },
  "mobile": {
    "tabs": {
      "home": "Home"
    },
    "auth": {
      "showPassword": "Show password",
      "hidePassword": "Hide password",
      "welcome": "Welcome to Lista! We sent a verification link to {{email}}."
    },
    "home": {
      "greeting": "Hello,",
      "continue": "Continue shopping",
      "addTo": "Add to {{name}}",
      "activeLists": "Active lists",
      "itemsLeft": "Items to buy",
      "recent": "Recent lists",
      "seeAll": "See all"
    },
    "lists": {
      "longPressHint": "Long-press for more actions"
    },
    "list": {
      "emptyBody": "Tap Add item, then type or pick from your favorites. Tap an item to tick it off, swipe it to tick off or remove, long-press to edit."
    },
    "items": {
      "rowHint": "Double-tap to tick off. Swipe or long-press for more.",
      "unbuy": "Not bought"
    },
    "add": {
      "title": "Add to {{name}}",
      "done": "Done",
      "favorites": "Your favorites",
      "results": "Results",
      "emptyPrompt": "Type an item and press Enter to add it. Items you use and star appear here.",
      "longPressHint": "Long-press to set quantity, unit and a note",
      "addedQty": "Added · {{quantity}} on the list",
      "addedCount_one": "{{count}} item added",
      "addedCount_other": "{{count}} items added",
      "quickPicks": "Recently used and favorites"
    },
    "settings": {
      "languageHint": "Switching between English and Arabic restarts the app to change the layout direction.",
      "offlineHint": "Lists you've opened stay on screen if the connection drops. Full offline editing is planned.",
      "version": "Version {{version}}"
    },
    "reorder": {
      "moveUp": "Move up",
      "moveDown": "Move down",
      "hint": "Press and hold the handle, then drag to arrange.",
      "sortTitle": "Sort"
    },
    "sponsored": {
      "setCountry": "Set your country in Profile on the Lista website to see sponsored lists near you."
    }
  },
  "notifications": {
    "title": "Notifications",
    "openLabel": "Notifications",
    "unreadBadge_one": "1 unread notification",
    "unreadBadge_other": "{{count}} unread notifications",
    "markAllRead": "Mark all as read",
    "markRead": "Mark as read",
    "unread": "Unread",
    "empty": {
      "title": "No notifications",
      "body": "Share requests and permission changes appear here."
    },
    "shareRequested": "{{actor}} shared “{{list}}” with you ({{role}}). Accept it to start using the list.",
    "roleChanged": "{{actor}} changed your permission on “{{list}}” to “{{role}}”.",
    "review": "Review",
    "openList": "Open list",
    "someone": "Someone",
    "shareAccepted": "{{actor}} accepted “{{list}}” ({{role}}).",
    "shareDeclined": "{{actor}} declined “{{list}}”.",
    "listDeleted": "“{{list}}” is no longer available: its owner deleted their account."
  },
  "meals": {
    "title": "Recipes by cuisine",
    "cuisineTitle": "{{name}} recipes",
    "mealCount_one": "{{count}} recipe",
    "mealCount_other": "{{count}} recipes",
    "ingredientCount_one": "{{count}} ingredient",
    "ingredientCount_other": "{{count}} ingredients",
    "servings": "Serves {{count}}",
    "ingredients": "Ingredients",
    "ingredientsHint": "Untick what you already have, then add the rest to one or more lists.",
    "selectAll": "Select all",
    "clearAll": "Clear all",
    "selectedCount_one": "{{count}} selected",
    "selectedCount_other": "{{count}} selected",
    "toggleIngredient": "{{name}}, {{quantity}}",
    "addSelected": "Add selected to a list",
    "addAll": "Add all to a list",
    "addToListTitle": "Add ingredients to a list",
    "chooseList": "Choose a list",
    "noLists": "You have no list you can edit yet. Create a list first.",
    "confirmAdd_one": "Add {{count}} ingredient",
    "confirmAdd_other": "Add {{count}} ingredients",
    "added_one": "{{count}} ingredient added to {{list}}",
    "added_other": "{{count}} ingredients added to {{list}}",
    "openList": "Open list",
    "nothingSelected": "Select at least one ingredient",
    "tally": "of {{total}} selected",
    "chooseLists": "Add to these lists",
    "newList": "New list",
    "newListName": "Name of the new list",
    "cancelNewList": "Don't create a new list",
    "noTarget": "Choose a list or create a new one",
    "noListsYet": "No lists yet - create a new one for this recipe.",
    "listCount_one": "{{count}} list",
    "listCount_other": "{{count}} lists",
    "addToLists_one": "Add {{count}} ingredient to {{lists}}",
    "addToLists_other": "Add {{count}} ingredients to {{lists}}",
    "empty": "No recipes here yet",
    "mealsEmpty": "No cuisines yet"
  },
  "archivedPage": {
    "title": "Archived lists",
    "empty": {
      "title": "No archived lists",
      "body": "Archive lists you are done with and they will appear here."
    }
  },
  "ai": {
    "suggest": "Suggest items with AI",
    "title": "Suggest items",
    "optional": "Optional: let AI propose the items",
    "description": "What is this list for?",
    "descriptionPlaceholder": "e.g. Iftar dinner for 6 people, no seafood",
    "frequency": "How often",
    "frequencies": {
      "ONE_TIME": "One time",
      "DAILY": "Daily",
      "WEEKLY": "Weekly"
    },
    "locationHint": "Suggestions use your country ({{country}}).",
    "setLocation": "Set your country in Profile for better suggestions.",
    "go": "Suggest",
    "again": "Try again",
    "working": "Thinking of items…",
    "source": {
      "ai": "Written by AI - check before you shop.",
      "rules": "Built-in suggestions (AI is not set up)."
    },
    "select": "Select the items to add ({{selected}}/{{total}})",
    "toggle": "Add {{name}}",
    "quantity": "Quantity of {{name}}",
    "add": "Add {{count}} items",
    "added": "Added {{count}} items to {{name}}",
    "later": "Skip",
    "errors": {
      "empty": "No suggestions for that. Try describing the list differently.",
      "generic": "Could not get suggestions right now."
    },
    "scan": {
      "button": "Scan a paper list",
      "title": "Items from your photo",
      "reading": "Reading your list…",
      "review": "Check what we read. Untick anything that is wrong, then add the rest.",
      "newItem": "New item: added to your items",
      "add_one": "Add {{count}} item",
      "add_other": "Add {{count}} items",
      "added_one": "Added {{count}} item from your photo",
      "added_other": "Added {{count}} items from your photo",
      "none": "No items found on this photo",
      "noneBody": "Try again with the whole list in the frame, flat and well lit.",
      "upload": "Upload a photo of a list",
      "chooseAnother": "Choose another photo",
      "retake": "Take another photo",
      "notImage": "That file isn’t a photo we can read. Choose a JPEG, PNG or WebP image.",
      "privacy": "Your photo is sent to our AI provider only to read the list. It isn’t stored."
    }
  },
  "sponsored": {
    "title": "Sponsored lists",
    "label": "Sponsored",
    "by": "By {{name}}",
    "open": "Open {{title}}",
    "itemCount_one": "{{count}} item",
    "itemCount_other": "{{count}} items",
    "selectItems": "Items ({{selected}}/{{total}})",
    "chooseLists": "Add to which lists?",
    "noLists": "Create a list first, then add these items to it.",
    "addButton_one": "Add {{count}} item to {{lists}} list",
    "addButton_other": "Add {{count}} items to {{lists}} list(s)",
    "added": "Added {{count}} items to {{lists}}",
    "toggle": "Add {{name}}",
    "items": "Items",
    "nothingSelected": "Select at least one item",
    "noListsYet": "No lists yet - create a new one for these items.",
    "addToLists_one": "Add {{count}} item to {{lists}}",
    "addToLists_other": "Add {{count}} items to {{lists}}",
    "admin": {
      "title": "Sponsored lists",
      "intro": "Lists shown on the home page of users in the countries and cities you choose. Users cannot edit them.",
      "new": "New sponsored list",
      "add": "New list",
      "edit": "Edit sponsored list",
      "create": "Create",
      "empty": {
        "title": "No sponsored lists yet",
        "body": "Create a list, choose where it appears and publish it."
      },
      "forbidden": "You do not have access to this page.",
      "fields": {
        "title": "Title",
        "sponsor": "Sponsor or brand",
        "description": "Description",
        "status": "Status",
        "startsAt": "Starts",
        "endsAt": "Ends",
        "color": "Colour"
      },
      "status": {
        "DRAFT": "Draft",
        "PUBLISHED": "Published",
        "ARCHIVED": "Archived"
      },
      "targets": {
        "title": "Where it appears",
        "hint": "Add a country for everyone there, or a country and a city for that city only.",
        "country": "Country",
        "city": "City (optional)",
        "add": "Add place",
        "remove": "Remove {{place}}",
        "wholeCountry": "whole country",
        "none": "Add at least one place to publish."
      },
      "items": {
        "title": "Items",
        "searchPlaceholder": "Search the catalog…",
        "customPlaceholder": "Or type a brand product, e.g. Acme Dates 500g",
        "addCustom": "Add product",
        "remove": "Remove {{name}}",
        "none": "Add at least one item.",
        "quantity": "Quantity of {{name}}"
      },
      "save": "Save",
      "saved": "Sponsored list saved",
      "deleted": "Sponsored list deleted",
      "deleteTitle": "Delete this sponsored list?",
      "deleteBody": "It disappears for every user. This cannot be undone.",
      "schedule": "{{from}} – {{to}}",
      "always": "Always on",
      "places_one": "{{count}} place",
      "places_other": "{{count}} places",
      "errors": {
        "title": "Enter a title",
        "sponsor": "Enter the sponsor name",
        "items": "Add at least one item",
        "targets": "Add at least one place to publish",
        "dates": "The end must be after the start"
      },
      "hidden": {
        "draft": "Not visible to users: it is a draft. Edit it and set the status to Published.",
        "archived": "Not visible to users: it is archived.",
        "noPlaces": "Not visible to users: add at least one country.",
        "notStarted": "Not visible to users yet: it starts later.",
        "ended": "Not visible to users: its end date has passed."
      },
      "forYou": {
        "yes": "Live. You see it too (your profile: {{place}}).",
        "noCountry": "Live, but not for you: your profile has no country. Set it in Profile.",
        "otherCountry": "Live, but not for you: your profile is in {{place}}, which is not one of its places.",
        "otherCity": "Live, but not for you: your profile city ({{place}}) is spelled differently from its cities. Add the whole country or your city as written in your profile."
      }
    },
    "setCountry": {
      "body": "Set your country to see offers near you.",
      "action": "Set country"
    }
  },
  "publicList": {
    "viewOnly": "View only",
    "live": "Live",
    "liveHint": "Updates automatically",
    "sharedBy": "Shared by {{name}}",
    "allBought": "Everything is bought",
    "bought": "Bought ({{count}})",
    "empty": "This list is empty.",
    "archived": "This list is archived.",
    "invalidTitle": "This link isn't available",
    "invalidBody": "It may have expired or been turned off by the owner. Ask them for a new link.",
    "ctaTitle": "Keep your own shopping lists with Lista",
    "ctaBody": "Create lists, add items from the catalog, and share them with family and friends - free.",
    "register": "Create a free account",
    "login": "I already have an account",
    "home": "Lista home",
    "offline": "Connection lost - showing the last update.",
    "remainingLabel_one": "item left",
    "remainingLabel_other": "items left",
    "updated": "Updated {{date}}",
    "validUntil": "Link valid until {{date}}",
    "order": {
      "category": "By category",
      "list": "List order",
      "name": "Name (A–Z)"
    }
  },
  "landing": {
    "meta": {
      "title": "Lista - fill your shopping list in seconds and share it live",
      "description": "Lista is a free shopping list app for web and phone. Add items by search, category, recipe, AI suggestion or your own entry, and share live lists with family and friends."
    },
    "nav": {
      "addItems": "Add items",
      "sharing": "Sharing",
      "features": "Features",
      "login": "Login",
      "register": "Register",
      "home": "Lista home",
      "menu": "Main"
    },
    "hero": {
      "eyebrow": "Shopping lists, made easy",
      "title": "Fill your list in seconds. Shop it together.",
      "body": "Search, browse by aisle, pick a recipe, let AI suggest the items or type your own. Then share the list with the people you shop with, so everyone works from the same up-to-date list.",
      "cta": "Create your free account",
      "login": "I already have an account",
      "note": "Free · English and Arabic · Web and phone",
      "imageAlt": "Lista on a computer showing colourful shopping lists",
      "phoneAlt": "A shared shopping list on a phone"
    },
    "add": {
      "title": "Five easy ways to add items",
      "intro": "Use whichever is quickest right now. Everything lands on the same list.",
      "tabsLabel": "Ways to add items",
      "w": {
        "search": {
          "tab": "Search",
          "title": "Type a few letters",
          "body": "Results appear as you type, in English or Arabic, and search understands plurals and spelling variations. Tap + to add an item with its usual unit.",
          "b": [
            "Hundreds of everyday items, ready to add",
            "See what is already on your list",
            "Recent items and favourites are one tap away"
          ],
          "alt": "Search results for cheese, each with an add button"
        },
        "categories": {
          "tab": "Categories",
          "title": "Browse by aisle",
          "body": "Not sure what you need? Open a category - produce, dairy, meat, bakery, pantry, cleaning, baby and more - and tap what you want.",
          "b": [
            "Clear categories with icons",
            "Add several items without leaving the panel",
            "Your own items get a category too"
          ],
          "alt": "The add items panel showing categories with icons"
        },
        "meals": {
          "tab": "Recipes",
          "title": "Pick a recipe, get its ingredients",
          "body": "Choose a dish from Arabian, Italian, Indian or Mexican cuisine, untick what you already have at home and add the rest to a list in one tap.",
          "b": [
            "Ingredients and amounts for every recipe",
            "Every dish shown as a picture card",
            "Items already on the list are merged, not duplicated"
          ],
          "alt": "A recipe with its ingredients and an Add all to a list button"
        },
        "ai": {
          "tab": "AI suggestions",
          "title": "Describe it, let AI fill it",
          "body": "Tell Lista what the list is for - “Iftar dinner for 6, no seafood” - and it proposes items and amounts. Untick what you don't want and add the rest.",
          "b": [
            "Takes your country into account",
            "Nothing is added until you approve",
            "Built-in suggestions when AI is not available"
          ],
          "alt": "Suggested items with checkboxes and amounts"
        },
        "manual": {
          "tab": "Your own items",
          "title": "Add anything, your way",
          "body": "Can't find it in the catalog? Type the name and add it as your own item, with a quantity, unit and note. Lista remembers it for next time.",
          "b": [
            "Quantity, unit and notes on every item",
            "Saved to My items so you can find it again",
            "Change any item later"
          ],
          "alt": "Adding a new item with quantity, unit and a note"
        }
      }
    },
    "share": {
      "eyebrow": "Live sharing",
      "title": "Shop together, on the same list",
      "intro": "Share a list with family, flatmates or friends. Whoever is at the shop sees what is left, and whoever is at home keeps adding.",
      "together": {
        "title": "Everyone works on one list",
        "body": "When Omar adds dates or ticks the bread, Sara sees it on her list too. The list header shows who it is shared with and whether you can edit.",
        "b": [
          "Invite people by email as editors or viewers",
          "Changes sync across phones and computers",
          "Only the owner can rename, recolour or delete the list"
        ]
      },
      "ownerTag": "Sara · owner",
      "partnerTag": "Omar · can edit",
      "ownerAlt": "Sara's phone showing the shared Weekly groceries list",
      "partnerAlt": "Omar's phone showing the same list, which he can edit",
      "invite": {
        "title": "Invite people or send a link",
        "body": "Add people by email, or create a read-only link and send it on WhatsApp, Telegram or email. Anyone who opens it sees the live list - no account needed.",
        "b": [
          "The link page refreshes every few seconds",
          "Links expire, and you can turn one off at any time",
          "Prefer paper? Download or share the list as a PDF"
        ],
        "alt": "The share dialog with an active link and two people",
        "linkAlt": "A shared list opened from a link on a phone, marked Live"
      }
    },
    "featuresTitle": "Built for the way you shop",
    "featuresIntro": "Everything else that makes the weekly shop easier.",
    "f": {
      "listview": {
        "title": "A list that works while you shop",
        "body": "Tick items off as they go in the trolley. Bought items move out of the way, and the header shows how many are left.",
        "b": [
          "Grouped by aisle, or in your own order",
          "Find, filter by category and switch between rows and tiles",
          "Quantities, units and notes at a glance"
        ],
        "alt": "A shopping list grouped by category with quantities"
      },
      "favorites": {
        "title": "Favourites for the things you always buy",
        "body": "Star an item once and it is always one tap away, in every list.",
        "b": [
          "Your own favourites page, grouped by aisle",
          "Favourite from any list or search result",
          "Add straight to the list you choose"
        ],
        "alt": "The favourites page grouped by category"
      }
    },
    "extrasTitle": "And there is more",
    "extras": {
      "colours": {
        "title": "Colourful lists",
        "body": "Give every list its own colour, pin the important ones, archive old ones and drag them into your order."
      },
      "sponsored": {
        "title": "Offers from local stores",
        "body": "Ready-made lists from stores in your city, like a Ramadan basket. Add the items you want in one tap."
      },
      "pdf": {
        "title": "PDF export",
        "body": "Download a tidy PDF of any list, or share it straight from your phone."
      }
    },
    "moreTitle": "Made for everyone",
    "more": {
      "language": {
        "title": "Arabic and English",
        "body": "The whole app in both languages, with a proper right-to-left layout.",
        "alt": "Lista in Arabic with a right-to-left layout"
      },
      "dark": {
        "title": "Light and dark themes",
        "body": "Comfortable at the shop and after dark.",
        "alt": "Lista in dark mode"
      },
      "phone": {
        "title": "Made for your phone",
        "body": "Install it on your home screen and keep your lists even when the signal drops.",
        "alt": "Lista's list overview on a phone"
      }
    },
    "final": {
      "title": "Ready for an easier weekly shop?",
      "body": "Create your free account in a minute and fill your first list.",
      "cta": "Create your free account",
      "login": "Login"
    },
    "footer": {
      "rights": "© {{year}} Lista. All rights reserved."
    }
  },
  "legal": {
    "updated": "Last updated: {{date}}",
    "contactEmail": "support@onelista.com",
    "nav": {
      "privacy": "Privacy Policy",
      "terms": "Terms and Conditions",
      "cookies": "Cookie settings",
      "back": "Back to Lista",
      "label": "Legal"
    },
    "privacy": {
      "title": "Privacy Policy",
      "intro": "This policy explains what personal data Lista collects, why, how long we keep it and the rights you have. It is written to meet the Saudi Personal Data Protection Law (PDPL) and, for users in the European Union and European Economic Area, the General Data Protection Regulation (GDPR).",
      "sections": [
        {
          "title": "1. Who we are",
          "body": [
            "Lista (\"we\", \"us\") is the controller of the personal data described in this policy.",
            "For any privacy question or request, contact us at support@onelista.com."
          ]
        },
        {
          "title": "2. The data we collect",
          "body": [
            "• Account data: your email address, display name and password. We never store your password itself, only a one-way Argon2id hash of it.",
            "• Your content: lists, items, quantities, notes, custom items, favorites, recently used items and meal plans.",
            "• Sharing data: the people you share a list with, their role, and the email address of anyone you invite.",
            "• Preferences: language, theme, unit system and, if you choose to give them, your country and city.",
            "• Technical data: IP address, browser or app type and request identifiers, used for security and keeping the service running.",
            "• Messages we send you: account emails (verification, password reset, invitations) and in-app notifications.",
            "We do not collect payment data, precise location, contacts or any special category of personal data, and we do not buy data about you from others."
          ]
        },
        {
          "title": "3. Why we use it, and our legal basis",
          "body": [
            "• To provide the service you signed up for: your account, your lists, sharing and exports. Legal basis: performance of our contract with you (GDPR Art. 6(1)(b); PDPL Art. 6).",
            "• To keep the service secure: sign-in protection, rate limits and an audit log of security events. Legal basis: our legitimate interest in protecting you and the service (GDPR Art. 6(1)(f)) and our legal obligations.",
            "• To show sponsored lists and tailor list suggestions to your country and city, only if you provide them. Legal basis: your consent, which you can withdraw by removing them from your profile.",
            "• To fill in your country when you register, only if you allow your browser to share your location: your position, rounded to about 10 km, is sent to BigDataCloud, which tells us only the country. We do not store your position, and you can change the country before you register. Legal basis: your consent, given in your browser's location prompt.",
            "• To improve the shared catalog: when you add an item of your own (for example “za’atar blend”), our administrators see that name and how many people added it, never who. The name may join the catalog; your own item then becomes that catalog item on your lists. Legal basis: our legitimate interest in a better catalog for everyone.",
            "• To remember optional preferences on your device (such as list views). Legal basis: your consent through the cookie settings.",
            "• To send account emails you need, such as password resets. We do not send marketing emails.",
            "We do not sell your personal data, show you third-party advertising, build advertising profiles or make decisions about you that have legal or similarly significant effects based solely on automated processing."
          ]
        },
        {
          "title": "4. AI list suggestions and photos of paper lists",
          "body": [
            "When you ask Lista to suggest a list, we send our AI provider, Anthropic, what it needs to propose items: the description you type, how often you need the list, the language, the names of items already on the list and, if you added them to your profile, your city and country. We never send your name, email address or other lists.",
            "When you scan a paper list, the photo (shrunk on your device, without location data) is sent to Anthropic only to read the items written on it. We do not store or log the photo or what was read from it, and nothing is added to your list until you approve it. Avoid photographing anything else, such as people or documents.",
            "We do not log or store the description, and Anthropic processes this data on our behalf under a data processing agreement. Do not include personal or sensitive information in a description. If you prefer, you can create lists without using suggestions."
          ]
        },
        {
          "title": "5. Who we share data with",
          "body": [
            "• People you share a list with see its content, your display name and your role. Only a list owner sees members’ email addresses.",
            "• Anyone with a share link you create can read that list until you revoke the link. Share links never show emails.",
            "• Service providers that process data for us under contract: our hosting provider, our email provider (Hostinger), our AI provider (Anthropic) and, only when you share your location at registration, BigDataCloud. They may use the data only to provide their service to us.",
            "• Authorities, when the law requires it or to protect the rights and safety of our users."
          ]
        },
        {
          "title": "6. International transfers",
          "body": [
            "Some of our providers process data outside the Kingdom of Saudi Arabia or outside the EU/EEA, for example in the United States. When that happens we transfer only what is necessary and rely on the safeguards the law requires: the conditions for transfers under PDPL and its implementing regulations, and, for EU/EEA data, the European Commission’s Standard Contractual Clauses or an adequacy decision."
          ]
        },
        {
          "title": "7. Cookies and storage on your device",
          "body": [
            "Lista uses no advertising, analytics or third-party tracking cookies.",
            "• Strictly necessary: one cookie, lista_rt, keeps you signed in. It is HttpOnly, sent only to our sign-in endpoints, and lasts up to 30 days. We also keep a copy of pages you have opened so the app works offline. These cannot be switched off, because the app cannot work without them.",
            "• Preferences (optional): your language, theme, list view and sort order, and the lists you last added items to, stored in your browser’s local storage. With your consent we keep them between visits; without it they reset when you close the app.",
            "You can change your choice at any time from \"Cookie settings\" at the bottom of the page or in Settings."
          ]
        },
        {
          "title": "8. How long we keep data",
          "body": [
            "• Your account and content: until you delete them or your account.",
            "• Deleted lists: 30 days in \"Recently deleted\", then permanently removed.",
            "• After you delete your account: personal data is removed straight away from the live system and from backups within 35 days.",
            "• Generated PDF and data exports: 24 hours.",
            "• Sign-in sessions: expired or revoked sessions are deleted after 7 days.",
            "• Invitations: expire after 14 days and are deleted after 90 days.",
            "• In-app notifications: 90 days.",
            "• Security audit log: 13 months, with a pseudonymous identifier instead of your identity after account deletion."
          ]
        },
        {
          "title": "9. How we protect your data",
          "body": [
            "We use encrypted connections (HTTPS), hash passwords with Argon2id, keep sign-in tokens short-lived, limit access to personal data to what each part of the system needs and record security-relevant actions in an append-only audit log. No system is perfectly secure; if a breach affects your data we will notify you and the competent authority as the law requires."
          ]
        },
        {
          "title": "10. Your rights",
          "body": [
            "Under PDPL and GDPR you have the right to:",
            "• be informed about how your data is used (this policy);",
            "• access your data and get a copy of it in a readable format - use \"Download my data\" in Settings;",
            "• correct inaccurate data - edit your profile at any time;",
            "• have your data deleted - use \"Delete account\" in Settings;",
            "• withdraw consent at any time, without affecting processing before the withdrawal;",
            "• in the EU/EEA, restrict or object to processing based on legitimate interests and receive your data in a portable format.",
            "For anything you cannot do in the app, email support@onelista.com. We answer within 30 days. You can also complain to the Saudi Data and AI Authority (SDAIA) or, in the EU/EEA, to your local data protection authority."
          ]
        },
        {
          "title": "11. Children",
          "body": [
            "Lista is not intended for children under 16. If you are under 16, use Lista only with the consent of a parent or guardian. If you believe a child has given us personal data without that consent, contact us and we will delete it."
          ]
        },
        {
          "title": "12. Changes to this policy",
          "body": [
            "If we change this policy we will update the date above. If a change is significant, we will tell you in the app or by email before it applies, and ask for your consent again where the law requires it."
          ]
        }
      ]
    },
    "terms": {
      "title": "Terms and Conditions",
      "intro": "These terms are an agreement between you and Lista about your use of Lista on the web and in the mobile app. Please read them together with our Privacy Policy.",
      "sections": [
        {
          "title": "1. Accepting these terms",
          "body": [
            "By creating an account or using Lista you agree to these terms. If you do not agree, do not use the service."
          ]
        },
        {
          "title": "2. Your account",
          "body": [
            "You must be at least 16, or have a parent’s or guardian’s consent, and give accurate information when you register. Keep your password secret; you are responsible for activity on your account. Tell us at support@onelista.com if you think someone else has accessed it."
          ]
        },
        {
          "title": "3. The service",
          "body": [
            "Lista lets you create shopping lists, share them, plan meals and export lists. The service is provided free of charge. We may add, change or remove features, and will try to give notice of changes that matter to you."
          ]
        },
        {
          "title": "4. Your content",
          "body": [
            "Your lists and the content you add remain yours. You give us the permission we need to store, process and show that content to you and to the people you share it with, only to provide the service.",
            "You are responsible for what you add and share. Do not add content you do not have the right to share."
          ]
        },
        {
          "title": "5. Sharing and share links",
          "body": [
            "When you share a list, the people you invite can see it and, if you make them editors, change its items. Anyone with a share link can read the list until you revoke the link, so share links only with people you trust."
          ]
        },
        {
          "title": "6. Acceptable use",
          "body": [
            "You agree not to:",
            "• break the law or the rights of others, including through content you share;",
            "• send spam or unwanted invitations;",
            "• try to access other people’s lists or accounts, or bypass security or rate limits;",
            "• disrupt, overload or reverse-engineer the service, or use automated means to access it except through the app.",
            "We may suspend or close accounts that break these rules."
          ]
        },
        {
          "title": "7. AI suggestions and sponsored lists",
          "body": [
            "AI-generated list suggestions are ideas only and may be incomplete or wrong; check them before you rely on them. Nothing is added to your list until you confirm it.",
            "Sponsored lists are clearly labelled, read-only and provided by partners. We are not responsible for partners’ products or offers."
          ]
        },
        {
          "title": "8. Availability",
          "body": [
            "We work to keep Lista available and your data safe, but we cannot promise the service will always be uninterrupted or error-free. Keep your own copy of anything important; you can export your data at any time."
          ]
        },
        {
          "title": "9. Liability",
          "body": [
            "Lista is provided \"as is\". To the extent the law allows, we are not liable for indirect or consequential loss, or for loss caused by your content, by other users or by events beyond our reasonable control. Nothing in these terms limits liability that cannot be limited by law, or your mandatory rights as a consumer."
          ]
        },
        {
          "title": "10. Ending your use",
          "body": [
            "You can stop using Lista and delete your account at any time from Settings. We may suspend or end your access if you seriously or repeatedly break these terms, and will tell you why unless the law prevents it."
          ]
        },
        {
          "title": "11. Governing law",
          "body": [
            "These terms are governed by the laws of the Kingdom of Saudi Arabia, and the competent courts of the Kingdom have jurisdiction. If you live in the EU/EEA, you also keep the protection of the mandatory consumer laws of your country and may bring a claim there."
          ]
        },
        {
          "title": "12. Changes and contact",
          "body": [
            "We may update these terms. If a change is significant we will tell you before it applies; if you keep using Lista after that, the new terms apply. Questions: support@onelista.com."
          ]
        }
      ]
    },
    "consent": {
      "title": "Your privacy choices",
      "body": "Lista uses one cookie to keep you signed in and stores a few things on your device so the app works. With your consent we also remember optional preferences, such as list views, between visits. We use no tracking or advertising cookies.",
      "acceptAll": "Accept all",
      "essentialOnly": "Essential only",
      "customize": "Choose",
      "save": "Save choices",
      "learnMore": "Read the Privacy Policy",
      "essential": {
        "title": "Strictly necessary",
        "body": "Keeps you signed in and lets the app work offline. Always on."
      },
      "preferences": {
        "title": "Preferences",
        "body": "Remembers your language, theme, list views and the lists you add to."
      },
      "saved": "Your privacy choices are saved"
    },
    "register": {
      "agree": "I agree to the <terms>Terms and Conditions</terms> and have read the <privacy>Privacy Policy</privacy>.",
      "checkboxLabel": "I agree to the Terms and Conditions and have read the Privacy Policy",
      "required": "Please accept the Terms and Conditions to create an account"
    }
  },
  "catalogAdmin": {
    "title": "Catalog",
    "intro": "Curate the shared catalog everyone picks items from. Names many people add for themselves can join it, so the next person finds them ready.",
    "add": "Add item",
    "addTitle": "Add a catalog item",
    "added": "Added {{name}} to the catalog",
    "tabs": {
      "suggestions": "Suggested by users",
      "items": "Catalog items"
    },
    "suggestionsHint": "Items people added for themselves (filed under \"My Items\"), most common first. You see each name and how many people use it, never who.",
    "noSuggestions": {
      "title": "No suggestions yet",
      "body": "When someone adds an item of their own, it shows up here."
    },
    "usersCount_one": "{{count}} person",
    "usersCount_other": "{{count}} people",
    "usesCount_one": "on {{count}} list",
    "usesCount_other": "on {{count}} lists",
    "lastUsed": "last used {{date}}",
    "inCatalog": "Already in the catalog as {{name}}",
    "promote": "Add to catalog",
    "promoteTitle": "Add “{{name}}” to the catalog",
    "promoted_one": "{{name}} is in the catalog. {{count}} person’s item now uses it.",
    "promoted_other": "{{name}} is in the catalog. {{count}} people’s items now use it.",
    "merge": "Merge",
    "mergeTitle": "Merge “{{name}}”?",
    "mergeBody": "The items {{count}} people named “{{name}}” become the catalog item “{{into}}”, on their lists and favorites too. This can’t be undone.",
    "searchPlaceholder": "Search in English or Arabic",
    "searchLabel": "Search catalog items",
    "allCategories": "All categories",
    "statusLabel": "Status",
    "status": {
      "all": "All",
      "active": "Active",
      "inactive": "Inactive"
    },
    "noItems": "No catalog items match",
    "editName": "Edit {{name}}",
    "editTitle": "Edit catalog item",
    "save": "Save",
    "saved": "Saved {{name}}",
    "forbidden": "You don’t have access to the catalog administration.",
    "fields": {
      "nameEn": "Name in English",
      "nameAr": "Name in Arabic",
      "category": "Category",
      "unit": "Default unit",
      "active": "Active",
      "activeHint": "Inactive items are hidden from browsing and search but stay on lists that use them.",
      "required": "Required"
    },
    "whoLabel": "Added by",
    "who": {
      "all": "Anyone",
      "common": "2+ people"
    },
    "noCommon": "No item has been added by two or more people yet."
  },
  "adminHub": {
    "title": "Admin",
    "intro": "Manage what everyone sees in Lista.",
    "sponsoredBody": "Lists shown to people in a country or city.",
    "catalogBody": "The shared catalog and items suggested by users."
  }
}
